import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38b61a7d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38b61a7d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b61a7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b61a7d')) {
      api.createRecord('38b61a7d', component.options)
    } else {
      api.reload('38b61a7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38b61a7d&scoped=true", function () {
      api.rerender('38b61a7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/Search/index.vue"
export default component.exports